import React from "react";

const Footer = () => {
    return (
        <nav className="bg-[#454B5A] shadow ">
            <div className="max-w-7xl mx-auto py-2 px-4 sm:px-6 lg:px-8">
            <p class="text-white text-center">Copyright © 2024,<a href="/" > T-FLIX </a>, All Rights Reserved. Powered By Tiwari's</p></div>
        </nav>
    );
};
export default Footer;
